export const VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
}

export const MODE = {
  READ: 'read',
  EDIT: 'edit',
}
